import React, {useState} from "react";
import useEditableTableNumberCell from "../../../hooks/useEditableTableNumberCell";


export default function JobWorkshopConfigRow({data, index, onChange, onSave}){
    const [editable, setEditable] = useState(false);

    const handleSave = () => {
        onSave(data, index);
        setEditable(false);
    }

    return (
        <tr key={data.id}>
            {useEditableTableNumberCell({
                propName: "warning_days",
                value: data.warning_days,
                onChange: (e) => onChange(e, index),
                onSave: handleSave,
                editable,
                setEditable,
                inlineEdit: true
            })}
            {useEditableTableNumberCell({
                propName: "danger_days",
                value: data.danger_days,
                onChange: (e) => onChange(e, index),
                onSave: handleSave,
                editable,
                setEditable,
                inlineEdit: true
            })}
        </tr>
    )
}